import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from '@/components/action-sheet';

export interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

export const CancelConfirmationActionSheet: React.FC<Props> = ({
  onConfirm,
  onCancel,
}) => {
  return (
    <ActionSheet
      actions={[
        i18n.t('edit_cancel_modal.stay'),
        i18n.t('edit_cancel_modal.leave'),
      ]}
      isVisible
      message={i18n.t('exit_confirmation.message')}
      onAction={(action) => {
        if (action === i18n.t('edit_cancel_modal.stay')) {
          onCancel();
        }
        if (action === i18n.t('edit_cancel_modal.leave')) {
          onConfirm();
        }
      }}
      onClose={onCancel}
      title={i18n.t('edit_cancel_modal.title')}
    />
  );
};
